import {AfterViewInit, Component, ComponentFactoryResolver, ComponentRef, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {CarsService} from '../../cars.service';
import {faCartPlus, faHeart as fasFaHeart, faMapMarkerAlt, faShoppingCart, faTimes} from '@fortawesome/free-solid-svg-icons';
import {faHeart as farFaHeart} from '@fortawesome/free-regular-svg-icons';
import {CarDialogOverviewComponent} from '../../car-dialog-overview/car-dialog-overview.component';
import {NbDialogConfig, NbDialogService} from '@nebular/theme';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {CalculatorCarsComponent} from '../../../calculator/calculator-cars.component';
import {BehaviorSubject, forkJoin} from 'rxjs';
import {CalculatorService} from '../../../calculator/calculator.service';
import {MyCarModalComponent} from '../my-car-modal/my-car-modal.component';
import {selectLoginState} from '../../../auth/login/selectors/login.selectors';
import {map} from 'rxjs/operators';
import {notificationsFeatureKey} from '../../../reducers/notification/notification.reducer';
import {getNotifications} from '../../../reducers/notification/notification.actions';
import * as _ from 'lodash';
import {Store} from '@ngrx/store';
import {AppState} from '../../../reducers';
import {CurrencyService} from '../../../services/currency.service';
import {LocaleService} from '../../../services/locale.service';


export interface DialogData {
  car: any;
}

declare let dataLayer: Array<any>;

@Component({
  selector: 'app-cars-grid',
  templateUrl: './cars-grid.component.html',
  styleUrls: ['./cars-grid.component.scss']
})
export class CarsGridComponent implements OnInit, AfterViewInit {


  constructor(
    private carsService: CarsService,
    private calculatorService: CalculatorService,
    public dialogService: NbDialogService,
    private breakpointObserver: BreakpointObserver,
    public dialog: MatDialog,
    private componentFactoryResolver: ComponentFactoryResolver,
    private store: Store<AppState>,
    public currencyService: CurrencyService,
    public localeService: LocaleService
  ) {
  }
  @ViewChild('host', {read: ViewContainerRef}) host: ViewContainerRef;
  calcRef: ComponentRef<CalculatorCarsComponent>;
  isLoading = new BehaviorSubject<boolean>(false);
  // vehicleValue = new BehaviorSubject<any>(null);

  fasFaHeart = fasFaHeart;
  farFaHeart = farFaHeart;
  faCartPlus = faCartPlus;
  faShoppingCart = faShoppingCart;

  user: any;
  customerType: any;
  cars = [];
  currencies: any;
  importType: 'Commercial' | 'Taxi' = 'Commercial';

  protected readonly faMapMarkerAlt = faMapMarkerAlt;

  protected readonly faTimes = faTimes;

  ngOnInit() {
    this.currencyService.ensureLoaded();
    this.initialize();
  }

  initialize() {

    this.store.select(selectLoginState).pipe(map(lState => {
      if (lState.isLogin) {
        this.user = lState.userData;
        this.customerType = this.hasRole('commercial_importer') ? 'commercial' : 'personal';
        this.carsService.getMyList().subscribe((cars: any) => {
          this.cars = cars.map((car) => ({
            ...car,
            isLiked: car.interest === 'Liked'
          }));
        });
      }
      // return lState;
    })).subscribe();



    // forkJoin([
    //   this.carsService.getMyList(),
    //   // this.calculatorService.getCurrencies()
    // ]).subscribe(([cars]) => {
    //   this.cars = cars.map((car) => ({
    //     ...car,
    //     isLiked: car.interest === 'Liked'
    //   }));
    //
    //   // this.currencies = currencies.data;
    //   // console.log(this.cars);
    //   // console.log(new Date().getTime());
    // });

  }

  hasRole(role: string): boolean {
    return this.user?.role?.includes(role);
  }

  ngAfterViewInit() {
    this.isLoading.next(true);
    // const factory = this.componentFactoryResolver.resolveComponentFactory(CalculatorCarsComponent);
    // this.calcRef = this.host.createComponent(factory);

    // this.calcRef.instance.calcInitialized.subscribe(() => {
    //   console.log('initialized');
    //   this.isLoading.next(false);
    //
    //   // this.initialize();
    // });

    this.isLoading.next(false);
    // this.calcRef.instance.initialize();

  }

  openDialog(car): void {
    const dialogRef = this.dialog.open(CarDialogOverviewComponent, {
      width: '80vw',
      data: {car}
    });
  }

  toggleLike(car) {
    car.isLiked = !car.isLiked;
    const interest = car.isLiked ? 'Liked' : 'Disliked';
    this.carsService.updateInterest(car.id, interest, 'Commercial').subscribe((res: any) => {
      console.log(res);
    });
  }

  toggleInterest(car) {
    this.carsService.updateInterest(car.id, 'Interested', 'Commercial').subscribe((res: any) => {
      console.log(res);
    });
  }

  isMobileView(): boolean {
    return this.breakpointObserver.isMatched(Breakpoints.Handset);
  }

  async toggleMoreInfo(car) {

    const isMobile = this.isMobileView();

    dataLayer.push({
      event: 'button_click_more_info_list',
      item_id: car.id,
      item_name: car.Manufacturer + ' ' + car.Model,
      item_price: car.CarPrice,
      item_year: car.ManufactureDate,
      user_id: sessionStorage.getItem('user-id'),
      userId: sessionStorage.getItem('user-id'),
    });

    let selectedCar = await this.carsService.getCarById(car.id, this.customerType).toPromise();
    if (Array.isArray(selectedCar)) {
      selectedCar = selectedCar[0];
    }

    const dialogConfig: NbDialogConfig<any> = {
      hasBackdrop: true,
      closeOnEsc: true,
      backdropClass: '',
      dialogClass: isMobile ? 'full-screen-dialog' : '',
      closeOnBackdropClick: false,
      hasScroll: false,
      autoFocus: false,
      viewContainerRef: undefined,
      context: {
        data: selectedCar ?? {},
        // currencies: this.currencies,
        isLoadingCalc: this.isLoading,
        // vehicleValue: this.vehicleValue
      }
    };

    // this.calculate(car);

    // const self = this;
    // const loadingSubscription = this.isLoading.subscribe(isLoading => {
    //   if (!isLoading) {
    //     this.vehicleValue.next(self.calculate(car) || {});
    //   }
    // });

    const dialogRef = this.dialogService.open(MyCarModalComponent, dialogConfig);

    if (isMobile) {
      dialogRef.componentRef.instance.nbDialogRef = dialogRef; // Set the dialogRef in the component
    }

    this.carsService.updateInterest(car.id, 'RequestedMoreInfo','Commercial').subscribe((res: any) => {
      console.log(res);
    });

    dialogRef.onClose.subscribe((result: any) => {
      // Action to be performed when the dialog closes
      console.log('Dialog closed', result);
      if (result?.code === 200) {
        // this.refreshCars();
        // this.cars$.subscribe(
        //     (res: any) => {
        //         this.carsList = res;
        //         console.log(this.carsList);
        //     }
        // );
      }
      // loadingSubscription.unsubscribe();
      // this.vehicleValue.next(null);
    });

  }

  getExwByExwId(data, id) {
    for (const option of data.options) {
      for (const exw of option.exw) {
        if (exw.id === id) {
          return exw;
        }
      }
    }

    return null;
  }

  getHarborByExwId(data, id) {
    return data.options.find(option =>
      option.exw.some(exw => exw.id === id)
    );
  }

  getDisHarborByExwId = (data, id) => {
    for (const option of data.options) {
      for (const exw of option.exw) {
        if (exw.id === id) {
          return exw.dHarbor;
        }
      }
    }

    return null;
  };

  calculate(car) {

    if (car.Location?.toLowerCase() === 'israel') {
      return {
        value: car.CarPrice,
      };
    }

    const ref = this.calcRef.instance;

    ref.vehicleForm.reset();
    ref.shipmentDetails.reset();
    ref.generalDetails.reset();

    // const currentYear = new Date().getFullYear();
    ref.onTaxYearChanged({year: new Date().getFullYear(), types: ref.data.vehicleTypes});

    const shipmentTypes = ref.data.shipmentTypes;

    //   [
    //   {
    //     id: 1,
    //     name: 'cfr',
    //     label: 'CFR נמל אשדוד / חיפה'
    //   },
    //   {
    //     id: 2,
    //     name: 'exw',
    //     label: 'EXW'
    //   },
    //   {
    //     id: 3,
    //     name: 'fca',
    //     label: 'FCA'
    //   }
    // ];

    let selectedShipmentType = shipmentTypes.find((shipmentType) => shipmentType.label.toLowerCase() === car.Rate?.type.toLowerCase());
    const exwSelectedCountry = car.Rate.type.toLowerCase() === 'exw' ?
      ref.data.countries.find((country) => country.name.toLowerCase() === car.Rate?.country.toLowerCase()) : '';
    const exwSelectedCity = car.Rate.type.toLowerCase() === 'exw' ?
      exwSelectedCountry.Cities.find((city) => city.city.toLowerCase() === car.Rate?.exwCity.toLowerCase()) : '';
    const exw = car.Rate.type.toLowerCase() === 'exw' ? this.getExwByExwId(exwSelectedCity, car.Rate?.exwRateId) : '';
    const exwSelectedHarbor = car.Rate.type.toLowerCase() === 'exw' ?
      this.getHarborByExwId(exwSelectedCity, car.Rate?.exwRateId) : '';
    const exwSelectedDisHarbor = car.Rate.type.toLowerCase() === 'exw' ?
      this.getDisHarborByExwId(exwSelectedCity, car.Rate?.exwRateId) : '';


    const fcaCountry = ref.data.fcaConfig.find((country) => country.label.toLowerCase() === car.Rate?.country.toLowerCase());

    const currency = ref.data.currencies.find((curr: any) => curr.name.toLowerCase() === car.CurrencyType.toLowerCase());

    const currentYear = new Date().getFullYear();
    let vehicleType = ref.data.vehicleTypes.find((vt) => {
      const vehicleTypeYear = new Date(vt.year).getFullYear();
      return vehicleTypeYear === currentYear && vt.name.toLowerCase() === car.FuelType?.toLowerCase();
    });

    vehicleType = {
      value: {...vehicleType},
      label: vehicleType.label
    };

    let vehicleCondition = ref.data.vehicleConditions.find((vc) => vc.name.toLowerCase() === car.SaleCondition?.toLowerCase());

    vehicleCondition = {
      value: {...vehicleCondition},
      label: vehicleCondition.label
    };

    const vehicleAirPollution = ref.data.vehicleAirPollution.find(element =>
      element.year === currentYear && element.rank === car.PollutionRank
    );

    // TODO: year is fixed to 2021
    const vehicleEquipmentLevel = ref.data.vehicleEquipmentLevels.find(element =>
      // element.year === currentYear &&
      element.rank === car.PollutionRank
    );

    selectedShipmentType = {
      ...selectedShipmentType,
      value: selectedShipmentType.name
    };

    ref.selectedSellingTypeChanged(selectedShipmentType);


    switch (selectedShipmentType.name) {
      case 'cfr':
        ref.shipmentPriceChanged({value: car.Rate.cfrPrice});

        const cfrCurrency = ref.data.currencies.find((curr: any) => curr.name.toLowerCase() === car.Rate.cfrCurrencyType.toLowerCase());
        ref.currencyChanged(cfrCurrency);

        const cfrCarType = car.Rate.cfrImportType.toLowerCase().split(' ').pop();
        const cfrShipmentMethod = ref.data.methods.find((sm) => sm.methodName.toLowerCase() === cfrCarType);
        console.log(cfrShipmentMethod);

        ref.shipmentMethodChanged(cfrShipmentMethod);

        if (car.TotalWeight === 1) {
          ref.lowWeight();
        } else if (car.TotalWeight === 2) {
          ref.avgWeight();
        } else if (car.TotalWeight === 3) {
          ref.highWeight();
        }
        ref.vehicleCurrencyChanged(currency);
        ref.vehiclePriceChanged({value: car.CarPrice});

        break;
      case 'exw':
        ref.exwSelectedCountryChanged(exwSelectedCountry);
        ref.exwCityChanged(exwSelectedCity);
        ref.exwHarborChanged(exwSelectedHarbor);
        ref.exwDischargeHarborChanged(exwSelectedDisHarbor);
        ref.exwVendorChange(exw);

        ref.exwShipmentMethodChange(exw.ExwShipmentMethods[0] || {});

        if (car.TotalWeight === 1) {
          ref.lowWeight();
        } else if (car.TotalWeight === 2) {
          ref.avgWeight();
        } else if (car.TotalWeight === 3) {
          ref.highWeight();
        }
        ref.vehicleCurrencyChanged(currency);
        ref.vehiclePriceChanged({value: car.CarPrice});

        break;
      case 'fca':
        ref.fcaSourceCountryChanged(fcaCountry);
        const sourceHarbor = fcaCountry.sourceHarbors
          .find((harbor) => harbor.code.toLowerCase() === car.Rate?.fcaHarbor.toLowerCase());
        ref.selectedFcaSourceHarborChanged(sourceHarbor);
        // TODO check match between [0] and discharge harbor on DB
        ref.selectedFcaDischargeHarborChanged(sourceHarbor.dischargeHarbors[0] || {});
        const vendor = sourceHarbor.dischargeHarbors[0].vendors[0];
        ref.fcaVendorSelectedChange(vendor);


        ref.fcaShipmentMethodChanged(vendor.shipmentMethods[0] || {});
        ref.vehicleCurrencyChanged(currency);
        ref.fcaPriceChanged({value: car.OverlandDeliveryPrice});
        ref.vehiclePriceChanged({value: car.CarPrice});


        if (car.TotalWeight === 1) {
          ref.lowWeight();
        } else if (car.TotalWeight === 2) {
          ref.avgWeight();
        } else if (car.TotalWeight === 3) {
          ref.highWeight();
        }

        // ref.vehicleCurrencyChanged(currency);
        // ref.vehiclePriceChanged({value: car.OverlandDeliveryPrice});

        break;
    }


    ref.vehicleTypeChanged(vehicleType);
    ref.vehicleConditionChanged(vehicleCondition);
    ref.vehicleAirPollutionChanged(vehicleAirPollution);
    ref.equipmentRatingChanged(vehicleEquipmentLevel);
    ref.sourceDiscountChange({value: car.CertificateOfOrigin === 'Yes'});
    ref.transportInsurance({value: false}); // TODO: starting with no insurance, per Boaz request
    ref.vehicleLegitPriceChanged({value: car.CarPrice * 4});

    return this.calcRef.instance.calculate(car);

  }

  removeFromList(carToRemove: any) {
    this.carsService.removeFromList(carToRemove.myCarId).subscribe((res: any) => {
      if (res.code === 200) {
        this.cars = this.cars.filter(car => car.myCarId !== carToRemove.myCarId);

      }
      console.log(res);
    });
  }

  getFuelTypeHebrew(type: any) {
    switch (type) {
      case '':
        return '';
      case 'diesel':
        return 'דיזל';
      case 'petrol':
        return 'בנזין';
      case 'hybrid':
        return 'היברידי';
      case 'electric':
        return 'חשמלי';
      case 'plug-in':
        return 'פלאג אין';

    }
  }
}



